import { render } from "./CreateAccount.vue?vue&type=template&id=19414de1"
import script from "./CreateAccount.vue?vue&type=script&lang=ts"
export * from "./CreateAccount.vue?vue&type=script&lang=ts"
script.render = render

export default script